(() => {
    if (!$('.default__item--default-content img').length) {
        return;
    }
    $.each($('.default__item--default-content img'), function (i, img) {
        if ($(this).closest('.bnr__item').length) {
            return;
        }
        const alt = $(img).attr('alt');
        if(alt && alt.length){
            $(img).wrap('<div class="default__item__inner_img"></div>');
            $(img).parent().append(`<div class="default__item__inner_img-desc">${alt}</div>`)
        }
    })
})();
